import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { formatAddress, formatNumber } from 'common/utils';

import Mana from 'assets/images/png/mana.png';

function before(second) {
  if (second < 60) {
    return `about ${second.toFixed(0)} seconds`;
  } else if (second < 3600) {
    return `about ${Math.floor(second / 60).toFixed(0)} minutes`;
  } else if (second < 86400) {
    return `about ${Math.floor(second / 3600).toFixed(0)} hour`;
  } else {
    return `about ${Math.floor(second / 86400).toFixed(0)} days`;
  }
}

export default function BidTable({ data = [] }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                FROM
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                PRICE
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                STATUS
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                SELLER
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                EXPIRATION
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow TableRow key={index}>
              <TableCell align="center">
                <Link
                  underline="none"
                  href={`https://etherscan.io/address/${row.bidAddress}`}
                  target="_blank"
                >
                  <Typography fontWeight="500">
                    {formatAddress(row?.bidAddress || '')}
                  </Typography>
                </Link>
              </TableCell>
              <TableCell
                align="center"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img style={{ height: 10 }} src={Mana} alt="Mana" />
                <Typography sx={{ fontWeight: 500 }}>
                  {formatNumber(row?.price || '')}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography
                  sx={{ textTransform: 'uppercase', fontWeight: 500 }}
                >
                  {row?.status || ''}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Link
                  underline="none"
                  href={`https://etherscan.io/address/${row.seller}`}
                  target="_blank"
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    {formatAddress(row?.seller)}
                  </Typography>
                </Link>
              </TableCell>
              <TableCell align="center">
                <Typography>
                  {before(row.expiresAt - Date.now() / 1000)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
